import tools from "../../../../assets/javascript/tools.js";
export default {
    columns: {
        customerName: {
            label: "顾客姓名",
            visible: true,
            width: "auto",
            align: "left",
        },
        mobile: {
            label: "联系方式",
            visible: true,
            width: "auto",
            minWidth: '120px',
            align: "left",
    },
    categoryName: {
      label: "分类",
      visible: true,
      width: "100",
      align: "left",
  },
        symptom: {
            label: "部位",
            visible: true,
            width: "auto",
            minWidth: 200,
            align: "left",
        },
        amount: {
            label: "档案金额",
            visible: true,
            width: "auto",
            align: "left",
        },
        repairStatusCn: {
            label: "档案状态",
            visible: true,
            width: "auto",
            align: "left",
        },
        nextRepairTime: {
            label: "下次登记时间",
            visible: true,
            formatDay: true,
            width: "120",
            align: "left",
        },
        validEndTime: {
            label: "过期/完成时间",
            visible: true,
            formatDay: true,
            width: "120",
            align: "left",
        },
    },
};